module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Thirty years is not a long time, yet in that period one comes in contact with a lot of people. Some of them are formally introduced with name cards. Some sit beside you on long trips over the Pacific. Others brush by on the street, or wave from the side of a dirt road, or stroll with you around a temple complex. Many have spent countless hours, decades really, patiently explaining Korea and Koreans, and in that process have transferred to me their love of the place, its constant beauty, and its clear, if sometimes melancholy, inner song. I am deeply grateful to them and can only apologize where I have fallen short as a student. There is always more for the heart to learn. To turn ideas into a book takes a great deal of encouragement and good advice along the way, not to mention an agent who is dedicated (Bob Mecoy), and an editor who is skilled (Pete Wolverton).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c7ecb26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312352080_epub_ack_r1.vue
// module id = 69
// module chunks = 0